import { SearchIdentifiersInterface as SearchIdentifiers } from '@videoblocks/events-ts/lib/storyblocks/search/records/SearchIdentifiers';

export default function searchIdentifiers(searchIdCookie: string | null, searchPageIdCookie: string | null): SearchIdentifiers | null {
    if (searchIdCookie && searchPageIdCookie) {
        return { searchId: searchIdCookie, searchPageId: searchPageIdCookie };
    }
    return null;
}
